/* src/components/SolarCTA/SolarCTAWithOutage.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert_hydration,
	listen,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	toggle_class
} from "svelte/internal";

import sendEvent from '../../helpers/svelte/sendEvent';
import Icon from '../Icon/Icon.svelte';
import gql from 'nanographql';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';
import { onMount } from 'svelte';

function create_else_block_1(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("Go Solar for less than your cell phone bill.");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t = claim_text(p_nodes, "Go Solar for less than your cell phone bill.");
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "solar-cta__title svelte-5yq2ld");
		},
		m(target, anchor) {
			insert_hydration(target, p, anchor);
			append_hydration(p, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (245:4) {#if totalCustomersOut > 0}
function create_if_block(ctx) {
	let p0;
	let t0;
	let p1;
	let t1;

	function select_block_type_1(ctx, dirty) {
		if (/*pageType*/ ctx[2] === 'provider') return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type_1(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			p0 = element("p");
			if_block.c();
			t0 = space();
			p1 = element("p");
			t1 = text("Are your lights on? They could be with a solar and battery install.");
			this.h();
		},
		l(nodes) {
			p0 = claim_element(nodes, "P", { class: true });
			var p0_nodes = children(p0);
			if_block.l(p0_nodes);
			p0_nodes.forEach(detach);
			t0 = claim_space(nodes);
			p1 = claim_element(nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t1 = claim_text(p1_nodes, "Are your lights on? They could be with a solar and battery install.");
			p1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "solar-cta__title svelte-5yq2ld");
			attr(p1, "class", "solar-cta__subheader");
		},
		m(target, anchor) {
			insert_hydration(target, p0, anchor);
			if_block.m(p0, null);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, p1, anchor);
			append_hydration(p1, t1);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(p0, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(p0);
			if_block.d();
			if (detaching) detach(t0);
			if (detaching) detach(p1);
		}
	};
}

// (249:8) {:else}
function create_else_block(ctx) {
	let t0_value = /*totalCustomersOut*/ ctx[0].toLocaleString() + "";
	let t0;
	let t1;
	let t2;
	let t3;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(" customers without electricity in ");
			t2 = text(/*name*/ ctx[3]);
			t3 = text(".");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, " customers without electricity in ");
			t2 = claim_text(nodes, /*name*/ ctx[3]);
			t3 = claim_text(nodes, ".");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
			insert_hydration(target, t2, anchor);
			insert_hydration(target, t3, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*totalCustomersOut*/ 1 && t0_value !== (t0_value = /*totalCustomersOut*/ ctx[0].toLocaleString() + "")) set_data(t0, t0_value);
			if (dirty & /*name*/ 8) set_data(t2, /*name*/ ctx[3]);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(t3);
		}
	};
}

// (247:8) {#if pageType === 'provider'}
function create_if_block_1(ctx) {
	let t0;
	let t1;
	let t2_value = /*totalCustomersOut*/ ctx[0].toLocaleString() + "";
	let t2;
	let t3;

	return {
		c() {
			t0 = text(/*name*/ ctx[3]);
			t1 = text(" has ");
			t2 = text(t2_value);
			t3 = text(" customers without electricity.");
		},
		l(nodes) {
			t0 = claim_text(nodes, /*name*/ ctx[3]);
			t1 = claim_text(nodes, " has ");
			t2 = claim_text(nodes, t2_value);
			t3 = claim_text(nodes, " customers without electricity.");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
			insert_hydration(target, t2, anchor);
			insert_hydration(target, t3, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*name*/ 8) set_data(t0, /*name*/ ctx[3]);
			if (dirty & /*totalCustomersOut*/ 1 && t2_value !== (t2_value = /*totalCustomersOut*/ ctx[0].toLocaleString() + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(t3);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let t0;
	let form;
	let input;
	let t1;
	let button_1;
	let t2;
	let button_1_class_value;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*totalCustomersOut*/ ctx[0] > 0) return create_if_block;
		return create_else_block_1;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			if_block.c();
			t0 = space();
			form = element("form");
			input = element("input");
			t1 = space();
			button_1 = element("button");
			t2 = text("Get Started");
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { title: true, class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", {});
			var div0_nodes = children(div0);
			if_block.l(div0_nodes);
			div0_nodes.forEach(detach);
			t0 = claim_space(div1_nodes);
			form = claim_element(div1_nodes, "FORM", { class: true });
			var form_nodes = children(form);

			input = claim_element(form_nodes, "INPUT", {
				maxlength: true,
				type: true,
				class: true,
				placeholder: true
			});

			t1 = claim_space(form_nodes);
			button_1 = claim_element(form_nodes, "BUTTON", { type: true, class: true });
			var button_1_nodes = children(button_1);
			t2 = claim_text(button_1_nodes, "Get Started");
			button_1_nodes.forEach(detach);
			form_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(input, "maxlength", "5");
			attr(input, "type", "text");
			attr(input, "class", "form-control");
			attr(input, "placeholder", "Zip code");
			attr(button_1, "type", "submit");
			attr(button_1, "class", button_1_class_value = "" + (/*buttonClass*/ ctx[1] + " solar-cta__btn btn" + " svelte-5yq2ld"));
			attr(form, "class", "solar-cta__form");
			attr(div1, "title", "More and more people are switching to solar as a means for powering their homes. If you're a home owner and your monthly bill is over $80, switching to solar could be a great option for long-term savings.");
			attr(div1, "class", "solar-cta is-cta svelte-5yq2ld");
			toggle_class(div1, "solar-cta--dark", /*theme*/ ctx[4] === 'dark');
			toggle_class(div1, "solar-cta--inline", /*type*/ ctx[5] === 'inline');
		},
		m(target, anchor) {
			insert_hydration(target, div1, anchor);
			append_hydration(div1, div0);
			if_block.m(div0, null);
			append_hydration(div1, t0);
			append_hydration(div1, form);
			append_hydration(form, input);
			set_input_value(input, /*zipcode*/ ctx[6]);
			append_hydration(form, t1);
			append_hydration(form, button_1);
			append_hydration(button_1, t2);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[16]),
					listen(form, "submit", prevent_default(/*handleSubmit*/ ctx[7]))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div0, null);
				}
			}

			if (dirty & /*zipcode*/ 64 && input.value !== /*zipcode*/ ctx[6]) {
				set_input_value(input, /*zipcode*/ ctx[6]);
			}

			if (dirty & /*buttonClass*/ 2 && button_1_class_value !== (button_1_class_value = "" + (/*buttonClass*/ ctx[1] + " solar-cta__btn btn" + " svelte-5yq2ld"))) {
				attr(button_1, "class", button_1_class_value);
			}

			if (dirty & /*theme*/ 16) {
				toggle_class(div1, "solar-cta--dark", /*theme*/ ctx[4] === 'dark');
			}

			if (dirty & /*type*/ 32) {
				toggle_class(div1, "solar-cta--inline", /*type*/ ctx[5] === 'inline');
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { pageType = '' } = $$props;
	let { id } = $$props;
	let { isSolarPage = true } = $$props;
	let { name = '' } = $$props;
	let { totalCustomers = 0 } = $$props;
	let { totalCustomersOut = 0 } = $$props;
	let totalOutageCustomers = 0;
	let totalServedCustomers = 0;
	let egKey = '';
	let { useRandom = true } = $$props;
	let { button = '' } = $$props;
	let { title = '' } = $$props;
	let { subheader = '' } = $$props;
	let { theme = 'dark' } = $$props;
	let { type = 'inline' } = $$props;
	let { placement = '' } = $$props;
	let { buttonClass = '' } = $$props;
	let zipcode = '';
	let url = '/out/energysage.com/';
	const randomButton = { className: ['btn-emerald'] };

	if (process.env.componentType === 'browser' && useRandom) {
		buttonClass = randomButton.className[Math.floor(Math.random() * randomButton.className.length)];
	} // for measuring CTA loads.
	/* sendEvent({
  category: 'affiliate',
  action: 'load',
  label: JSON.stringify({
    placement,
    campaign: 'solar',
    title,
    button,
    type,
    theme,
    subheader,
    zipcode,
    buttonClass,
  }),
  nonInteraction: true,
}); */

	// should technically use process.env.componentType === 'browser'
	// as well, but doesn't matter when only 1 option
	const delay = ms => new Promise(res => setTimeout(res, ms));

	const trackClick = async partner => {
		// commented out for non new tab nav
		// e.preventDefault();
		sendEvent({
			category: 'affiliate',
			action: 'click',
			label: JSON.stringify({
				placement,
				campaign: 'solar',
				partner,
				title,
				button,
				type,
				theme,
				subheader,
				zipcode,
				buttonClass
			}),
			nonInteraction: false
		});

		return delay(100);
	};

	async function handleSubmit() {
		// new tab is for opening in new tab
		// const newTab = window.open();
		try {
			// const askSolarZips = await (await fetch('/asksolar-zips.json')).json();
			/* commented out because not currently needed
if (isSolarPage) {
} else {
} */
			// if (askSolarZips[zipcode]) {
			//   url = `/out/asksolar.com?zip=${zipcode}`;
			// } else {
			//   url = `/out/heliose.com?zip=${zipcode}&template=${window.__fetCDs?.template}`;
			// }
			url = `/out/energysage.com/?zip=${zipcode}`;

			return trackClick(url.replace('/out/', '').split('?')[0]).then(_ => window.location.assign(`https://findenergy.com${url}`)).catch(e => {
				console.error(e);
				window.location.assign(`https://findenergy.com${url}`);
			});
		} catch(e) {
			console.error(e);
			window.location.assign(`https://findenergy.com${url}`);
		}
	}

	const getProviderOutage = gql`
    query providerOutages($id: Int!) {
      provider: allProviderOutageData(condition: { providerId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
      outages: allProviderCountyOutageData(condition: { providerId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
    }
  `;

	const getCountyOutage = gql`
    query countyOutage($id: Int!) {
      outages: allCountyOutageData(condition: { countyId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
    }
  `;

	const getStateOutage = gql`
    query stateOutage($id: Int!) {
      outages: allProviderStateOutageData(condition: { stateId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
    }
  `;

	const graphql = getGraphqlClient();

	// handle state
	const handleStatePageOnMount = async id => {
		const stateOutages = await graphql(getStateOutage({ id }), { 'eg-key': egKey });

		if (stateOutages.errors) {
			errors = stateOutages.errors;
		}

		const outages = stateOutages.data.outages.nodes;

		outages.forEach(({ outageCustomers, servedCustomers }) => {
			totalOutageCustomers += Number(outageCustomers);
			totalServedCustomers += Number(servedCustomers);
		});

		$$invalidate(0, totalCustomersOut = totalOutageCustomers);
		$$invalidate(8, totalCustomers = totalServedCustomers);
	};

	// handles both city and county
	const handleCountyPageOnMount = async id => {
		const countyOutages = await graphql(getCountyOutage({ id }), { 'eg-key': egKey });

		if (countyOutages.errors) {
			errors = countyOutages.errors;
		}

		const outages = countyOutages.data.outages.nodes;

		outages.forEach(({ outageCustomers, servedCustomers }) => {
			totalOutageCustomers += Number(outageCustomers);
			totalServedCustomers += Number(servedCustomers);
		});

		$$invalidate(0, totalCustomersOut = totalOutageCustomers);
		$$invalidate(8, totalCustomers = totalServedCustomers);
	};

	// handle provder
	const handleProviderPageOnMount = async id => {
		const providerOutages = await graphql(getProviderOutage({ id }), { 'eg-key': egKey });

		if (providerOutages.errors) {
			errors = providerOutages.errors;
		}

		const outages = providerOutages.data.outages.nodes;

		outages.forEach(({ outageCustomers, servedCustomers }) => {
			totalOutageCustomers += Number(outageCustomers);
			totalServedCustomers += Number(servedCustomers);
		});

		$$invalidate(0, totalCustomersOut = totalOutageCustomers);
		$$invalidate(8, totalCustomers = totalServedCustomers);

		if (provider) {
			const unknownData = {
				servedCustomers: provider.servedCustomers - totalServedCustomers > 0
				? provider.servedCustomers - totalServedCustomers
				: 0,
				outageCustomers: provider.outageCustomers - totalOutageCustomers > 0
				? provider.outageCustomers - totalOutageCustomers
				: 0
			};

			if (unknownData.servedCustomers > 0 || unknownData.outageCustomers > 0) providerOutageData.push(unknownData);
			if (provider.servedCustomers > totalCustomers) $$invalidate(8, totalCustomers = provider.servedCustomers);
			if (provider.outageCustomers > totalCustomersOut) $$invalidate(0, totalCustomersOut = provider.outageCustomers);
		}
	};

	onMount(async () => {
		const egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;

		if (pageType === 'state' && id) {
			await handleStatePageOnMount(id);
		}

		if (pageType === 'county' && id) {
			await handleCountyPageOnMount(id);
		}

		if (pageType === 'provider' && id) {
			await handleProviderPageOnMount(id);
		}
	});

	function input_input_handler() {
		zipcode = this.value;
		$$invalidate(6, zipcode);
	}

	$$self.$$set = $$props => {
		if ('pageType' in $$props) $$invalidate(2, pageType = $$props.pageType);
		if ('id' in $$props) $$invalidate(9, id = $$props.id);
		if ('isSolarPage' in $$props) $$invalidate(10, isSolarPage = $$props.isSolarPage);
		if ('name' in $$props) $$invalidate(3, name = $$props.name);
		if ('totalCustomers' in $$props) $$invalidate(8, totalCustomers = $$props.totalCustomers);
		if ('totalCustomersOut' in $$props) $$invalidate(0, totalCustomersOut = $$props.totalCustomersOut);
		if ('useRandom' in $$props) $$invalidate(11, useRandom = $$props.useRandom);
		if ('button' in $$props) $$invalidate(12, button = $$props.button);
		if ('title' in $$props) $$invalidate(13, title = $$props.title);
		if ('subheader' in $$props) $$invalidate(14, subheader = $$props.subheader);
		if ('theme' in $$props) $$invalidate(4, theme = $$props.theme);
		if ('type' in $$props) $$invalidate(5, type = $$props.type);
		if ('placement' in $$props) $$invalidate(15, placement = $$props.placement);
		if ('buttonClass' in $$props) $$invalidate(1, buttonClass = $$props.buttonClass);
	};

	return [
		totalCustomersOut,
		buttonClass,
		pageType,
		name,
		theme,
		type,
		zipcode,
		handleSubmit,
		totalCustomers,
		id,
		isSolarPage,
		useRandom,
		button,
		title,
		subheader,
		placement,
		input_input_handler
	];
}

class SolarCTAWithOutage extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			pageType: 2,
			id: 9,
			isSolarPage: 10,
			name: 3,
			totalCustomers: 8,
			totalCustomersOut: 0,
			useRandom: 11,
			button: 12,
			title: 13,
			subheader: 14,
			theme: 4,
			type: 5,
			placement: 15,
			buttonClass: 1
		});
	}
}

export default SolarCTAWithOutage;